import { render, staticRenderFns } from "./AiDoc.vue?vue&type=template&id=6325b9e6&scoped=true"
import script from "./AiDoc.vue?vue&type=script&lang=js"
export * from "./AiDoc.vue?vue&type=script&lang=js"
import style0 from "./AiDoc.vue?vue&type=style&index=0&id=6325b9e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6325b9e6",
  null
  
)

export default component.exports